import styled from 'styled-components';


export const HomeContainer = styled.div`
  background-color:#EBEBEE;
  height:100%;
  
`;
export const FlexBox=styled.div`
  display:flex;
  

  
`
export const HomeImageContainer = styled.div`
  padding-left:200px;
  width:55%;
  background-color:#EBEBEE;
  
`;

export const HomeImage = styled.img`  
mix-blend-mode: multiply; 
`;

export const HomeLoginContainer = styled.div`
padding:20px;
width: 24em;
min-height: calc(100vh)
max-height:  calc(100vh)
flex-shrink: 0;
border-radius: 32px;
background: #FFF;
  
`;

export const LoginHeader = styled.div`
color: #1A1A1A;
font-family: Product Sans;
font-size: 28px;
font-style: normal;
font-weight: 700;
line-height: 32px; /* 114.286% */
padding:25px;

  
`;

export const LoginInputField = styled.div`
margin-top:1px;
margin-left:30px;
display: flex;
flex-direction: row;
width: 80%;
height: 45px;
border: 1px solid #EBEBEE;
align-items: center;
flex-shrink: 0;
border-radius: 12px;
background: #FFF;
box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
`;

export const LoginInputPassword = styled.div`
margin-top:30px;
margin-left:30px;
flex-direction: row;
display: flex;
width: 80%;
height: 45px;
border: 1px solid #EBEBEE;
align-items: center;
flex-shrink: 0;
border-radius: 12px;
background: #FFF;
box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
`;
export const MailImage = styled.img`
width: 17.5px;
height: 14px;

flex-shrink: 0;
flex-shrink: 0;
padding:15px
`;
export const PasswordImage = styled.img`
width: 17px;
height: 22.313px;
flex-shrink: 0;
flex-shrink: 0;
padding:15px
`;
export const InputBox = styled.input`
width: 77%;
height:55%;
outline:none;
border:none;
color: var(--light-theme-595959, #595959);
font-family: Product Sans;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */

`;

export const TermConditionLine = styled.div`
color: var(--light-theme-595959, #595959);
font-family: Product Sans;
font-size: 13px;
font-style: normal;
font-weight: 400;
line-height: 20px; /* 142.857% */
padding-left:40px;
padding-top:5px;



`;

export const TermConditionLine1 = styled.div`
color: var(--light-theme-595959, #595959);
font-family: Product Sans;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 20px;
height: 2px;
padding-left:40px;
`;

export const NewUser = styled.div`
flex-direction: row;
display: flex;
float:right;

color: var(--light-theme-595959, #595959);
padding-top:30px;
padding-right:40px;
text-align: right;
font-family: Montserrat;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 20px; /* 142.857% */
`;
export const SignUp = styled.div`
color: #4285F4;
font-family: Montserrat;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 20px;
padding-left:5px;
cursor: pointer
`;
export const ForgotPassword = styled.div`
color: #4285F4;
font-family: Montserrat;
font-size: 12px;
font-style: normal;
font-weight: 700;
line-height: 20px;
padding-top: 30px;
padding-left: 32px;
cursor: pointer
`;
export const EmptyBox = styled.div`
width:100%;
height:5em;
`;
export const LoginButtonContainer = styled.div`
padding:25px;
width:90%
`;


export const LoginButton = styled.button`


width:100%;
height: 48px; 
justify-content: center;
align-items: center;


border-radius: 12px;
background: #4285F4;
border:none;
color:#FFFFFF;
outline:none;
cursor: pointer;

color: var(--light-theme-ffffff-100, #FFF);
text-align: center;
font-family: Product Sans;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 24px; /* 150% */
text-transform: uppercase;

`;
